module.exports = __webpack_public_path__ + "img/symbol_krone@2x.9d2a124.webp";